import AgricultureIcon from '@mui/icons-material/Agriculture';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import GrassIcon from '@mui/icons-material/Grass';
import PeopleIcon from '@mui/icons-material/People';
import PinDropIcon from '@mui/icons-material/PinDrop';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TuneIcon from '@mui/icons-material/Tune';
import { ReactComponent as UnitsSvg } from 'shared/assets/icons/units.svg';
import { ROUTES } from 'shared/constant/routes';

import { NavigationTab } from './types/navigationTab';

export const navigationTabsList: NavigationTab[] = [
  {
    text: 'monitoring',
    link: ROUTES.MONITORING,
    icon: PinDropIcon,
  },
  {
    text: 'tasks',
    link: ROUTES.TASKS,
    icon: PlaylistAddCheckIcon,
  },
  {
    text: 'devices',
    link: ROUTES.DEVICES,
    icon: DeviceHubIcon,
  },
  {
    text: 'calibrations',
    link: ROUTES.CALIBRATIONS,
    icon: TuneIcon,
  },
  {
    text: 'employees',
    link: ROUTES.EMPLOYEES,
    icon: PeopleIcon,
  },
  {
    text: 'machinery',
    link: ROUTES.MACHINERY,
    icon: AgricultureIcon,
  },
  {
    text: 'units',
    link: ROUTES.UNITS,
    icon: UnitsSvg,
  },
  {
    text: 'farmlands',
    link: ROUTES.FARMLANDS,
    icon: GrassIcon,
  },
  {
    text: 'statistic',
    link: ROUTES.STATISTIC,
    icon: TrendingUpIcon,
  },
];

export const navigationTabsLogout: NavigationTab = {
  text: 'logout',
  icon: ExitToAppIcon,
};
